import 'ui-core/components/drop-block/js/drop-block';

(function () {
    $(document).ready(function () {
        UX.dropBlock.additionalControl = function () {
            $('.dropBlock__holder a').click(function (e) {
                UX.dropBlock.on.hide();
            });
        };
        UX.dropBlock.additionalControl();
    });
})();
